var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.586 1.414L8 0l1.414 1.414L13 5h-2.828L8 2.828 2.828 8 8 13.172 10.172 11H13l-3.586 3.586L8 16l-1.414-1.414-5.172-5.172L0 8l1.414-1.414 5.172-5.172zM20 8l-1-1-3-3-1.5-.5L15 5l2 2H7.867L6 8l1.867 1H17l-2 2-.5 1.5L16 12l3-3 1-1z",
    fill: "#9A9CAC"
  })));
}

export default SvgSignOutIcon;